import { MenuItem } from '@mui/material'
import Grid from '@/global/components/ui/Grid'
import { periodicidade } from '@/locales/plan'
import { FormField } from 'global/components/Form'

export function FormPlano() {
    return (
        <Grid container rowSpacing={2} columnSpacing={3}>
            <Grid item xs={12}>
                <FormField
                    select
                    required
                    name="periodicity"
                    label="Periodicidade"
                >
                    {Object.entries(periodicidade).map(([value, label]) => (
                        <MenuItem key={value} value={value}>
                            {label}
                        </MenuItem>
                    ))}
                </FormField>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormField
                    required
                    type="number"
                    name="limiteFuncionarios"
                    label="Limite de funcionários"
                    min={0}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormField
                    required
                    name="precoReais"
                    label="Preço"
                    options={{
                        numeral: true,
                        numeralDecimalMark: ',',
                        delimiter: '.',
                        numeralDecimalScale: 2,
                        numeralPositiveOnly: true,
                    }}
                    InputProps={{
                        startAdornment: (
                            <span className="mt-auto mb-2 mr-2">R$</span>
                        ),
                    }}
                />
            </Grid>
        </Grid>
    )
}
